<template>
  <BaseLayout pageTitle="登录">
    <div class="login">
      <div class="h f-y-center m-b-55 m-l-75 m-r-75">
        <img class="RegisteredLogoImage" src="./assets/registered-logo.png" />
        <div class="f-x-center f-column">
          <div class="title m-b-15">欢迎使用律小购</div>
          <div class="label">法律人工智能服务平台</div>
        </div>
      </div>
      <div class>
        <div class="login-input-box">
          <img class="registeredInputNameImage icon" src="./assets/registered-input-name.png" />
          <input
            :ref="el =>
             nodes.accountNode.value = el"
            type="text"
            :class="{'input-error' : requiredErrorKey === 'account'}"
            class="input p-l-100"
            :value="form.account"
            @input="(e) => onInputChange('account', e)"
            placeholder="输入您的账号"
            @blur="blurEvent"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredInputPasswordImage icon"
            src="./assets/registered-input-password.png"
          />
          <input
            :ref="el => nodes.passwordNode.value = el"
            type="password"
            :class="{'input-error' : requiredErrorKey === 'password'}"
            class="input p-l-100"
            :value="form.password"
            @input="(e) => onInputChange('password', e)"
            placeholder="输入您的密码"
            @blur="blurEvent"
          />
        </div>
      </div>
      <!-- @keyup.enter="submit" -->

      <div class="login-input-box">
        <div class="submit" @click="submitEvent">登&nbsp;&nbsp;&nbsp;录</div>
      </div>
      <div class="to-retrieve-password" @click="toRetrievePassword">忘记密码了？</div>
      <!-- <div class="to-registered">
        <span>还没有账号了？</span>
        <span class="link" @click="toRegistered">立即注册</span>
      </div>-->
    </div>
  </BaseLayout>
</template>

<script>
import { ref, reactive } from 'vue'
import md5 from 'crypto-js/md5'
import router from '@/router'
import { delay, userApi } from '@/apis'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { toast, loadingCreate } from '@/utils/alert'

export default {
  setup() {
    const store = new useStore()
    const route = new useRoute()

    console.log('store', store.getters['user/token'])
    // store.dispatch
    const nodes = {
      accountNode: ref(null),
      passwordNode: ref(null),
    }

    const requiredErrorKey = ref('')

    const form = reactive({
      account: '',
      password: '',
    })
    const verify = {
      account: {
        isRequired: true,
        v: () =>
          /(?=.*\d+)^[a-zA-Z]\w{3,7}$/g.test(form.account) ||
          /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
            form.account
          ),
        msg: '账号设置字母开头包含字母和数字4-18位或邮箱',
      },
      password: {
        isRequired: true,
        v: () =>
          /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(form.password),
        msg: '密码设置包含字母和数字8-16位',
      },
    }

    const blurEvent = () => {
      requiredErrorKey.value = ''
    }

    const onInputChange = (key, e) => {
      const value = e.target.value.toLowerCase().trim()
      form[key] = value
    }

    const submitEvent = async () => {
      const verifyKeys = Object.keys(verify)
      const requiredKey = verifyKeys.find((key) => form[key] == '')
      if (requiredKey) {
        const key = requiredKey
        const node = nodes[`${key}Node`]
        node.value.focus()
        requiredErrorKey.value = key
        return
      }

      try {
        await store.dispatch('user/login', {
          account: form.account.toLowerCase(),
          md5Pwd: md5(form.password).toString(),
          accountType: '2',
          equipmentType: 'app',
        })
        await store.dispatch('dict/getDict')
        toast('登录成功')
        if (Boolean(route.query.isUploadFile)) {
          router.replace({
            path: '/uploadFile',
            query: {
              processNodeTblId: route.query.processNodeTblId,
              tblId: route.query.tblId,
            },
          })
        } else if (store.getters['user/role'].inputEd) {
          router.replace('/nativeTab/my')
        } else {
          router.replace('/certification/inputData')
        }
      } finally {
        // loading.dismiss()
      }
    }

    const toRetrievePassword = () => router.push('/retrievePasswordOne')
    const toRegistered = () => router.push('/registered')
    return {
      nodes,
      form,
      verify,
      onInputChange,
      blurEvent,
      submitEvent,
      requiredErrorKey,
      toRetrievePassword,
      toRegistered,
    }
  },
  // components: { ProgressBar },
}
</script>

<style lang="scss">
@import './utils.scss';

.login {
  display: flex;
  flex-direction: column;
  padding-top: 60px;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);
  .RegisteredLogoImage {
    width: 75px;
    height: 90px;
    margin-right: 28px;
  }
  .to-retrieve-password {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: #a2a2a2;
  }
  .to-registered {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 315px;
    color: #a2a2a2;
    font-size: 28px;
    .link {
      color: #3370ff;
    }
  }
}
</style>